import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    title: {
      marginBottom: theme.spacing(0.5),
      color: COLORS.gray.gray30,
    },
    message: {
      whiteSpace: 'pre-wrap',
      color: COLORS.gray.gray30,
    },
  }),
  { name: 'BlockedSectionContent' }
);
